import { SagaReduxAction, ReduxAction } from './helper';

export const requireBunkerPrices = new SagaReduxAction('FIREBASE_BUNKER_EX_BOOTSTRAP');
export const updateBunkerPrices = new ReduxAction('FIREBASE_BUNKER_EX_UPDATE', prices => prices);
export const updateBunkerStats = new ReduxAction('FIREBASE_BUNKER_EX_STATS_UPDATE', stats => stats);

export const updateBunkerPortsInBuffer = new ReduxAction('BUNKER_PORTS_IN_BUFFER_UPDATE', ports => ports);

export const updateBunkerPorts = new ReduxAction('BUNKER_PORTS_UPDATE', payload => payload);